import StringUtils from "./StringUtils";
import { OMY_SETTING, OmyConst } from "../OmyConst";

export default class OMath {
    static drawRectBorder(graphic, x, y, width, height, color = "#000000", lineWidth = 1, alpha = 1) {
        graphic.lineStyle(lineWidth, color, alpha);
        graphic.moveTo(x, y);
        graphic.lineTo(x + width, y);
        graphic.lineTo(x + width, y + height);
        graphic.lineTo(x, y + height);
        graphic.lineTo(x, y);
    }

    static convertSecondsToString(seconds, d = true, h = true, m = true, s = true) {
        let day = OMath.int(seconds / 86400);
        let hour = OMath.int((seconds - day * 86400) / 3600);
        let minutes = OMath.int((seconds - day * 86400 - hour * 3600) / 60);
        let sec = OMath.int((seconds - day * 86400 - hour * 3600 - minutes * 60));
        let result = "";

        if (d && day > 0) {
            result = day + " " + "d"/*g.language.get("formatTime", "day")*/;

            if (h) {
                result += " " + hour + " " + "h"/*g.language.get("formatTime", "hour")*/;
            }
            if (m) {
                result += " " + minutes + " " + "min"/*g.language.get("formatTime", "minutes")*/;
            }
            /*if (s) {
             result += " " + sec + " " + g.language.get("formatTime", "second");
             }*/
        } else if (h && hour > 0) {
            result = hour + " " + "h"/*g.language.get("formatTime", "hour")*/;

            if (m) {
                result += " " + minutes + " " + "min"/*g.language.get("formatTime", "minutes")*/;
            }
            if (s) {
                result += " " + sec + " " + "sec"/*g.language.get("formatTime", "second")*/;
            }
        } else if (m && minutes > 0) {
            result = minutes + " " + "min"/*g.language.get("formatTime", "minutes")*/;

            if (s) {
                result += " " + sec + " " + "sec"/*g.language.get("formatTime", "second")*/;
            }
        } else if (s && sec > 0) {
            result = sec + " " + "sec"/*g.language.get("formatTime", "second")*/;
        }
        return result;
    }

    static convertSecToStrSimple(seconds) {
        let day = OMath.int(seconds / 86400);
        let hour = OMath.int((seconds - day * 86400) / 3600);
        let minutes = OMath.int((seconds - day * 86400 - hour * 3600) / 60);
        let sec = OMath.int((seconds - day * 86400 - hour * 3600 - minutes * 60));

        return StringUtils.padZeros(minutes, 2) + ":" + StringUtils.padZeros(sec, 2);
    }

    static benchFunction(func, ...arr) {
        let date = new Date();
        for (let i = 0; i < 100000; i++) func(arr);
        return new Date() - date;
    }

    static sortNumber(list, sortProp, toUp = true) {
        if (toUp) {
            list.sort(function(a, b) {
                if (a[sortProp] > b[sortProp]) {
                    return 1;
                }
                if (a[sortProp] < b[sortProp]) {
                    return -1;
                }
                return 0;
            });
        } else {
            list.sort(function(a, b) {
                if (a[sortProp] > b[sortProp]) {
                    return -1;
                }
                if (a[sortProp] < b[sortProp]) {
                    return 1;
                }
                return 0;
            });
        }
    }

    static sortNumberBy2Field(list, sortProp1, sortProp2, toUp = true) {
        if (toUp) {
            list.sort(function(a, b) {
                return a[sortProp1] - b[sortProp1] || a[sortProp2] - b[sortProp2];
            });
        } else {
            list.sort(function(a, b) {
                return b[sortProp1] - a[sortProp1] || b[sortProp2] - a[sortProp2];
            });
        }
    }

    static sortNumberSimple(list, toUp = true) {
        if (toUp) {
            list.sort(function(a, b) {
                if (a > b) {
                    return 1;
                }
                if (a < b) {
                    return -1;
                }
                return 0;
            });
        } else {
            list.sort(function(a, b) {
                if (a > b) {
                    return -1;
                }
                if (a < b) {
                    return 1;
                }
                return 0;
            });
        }
    }

    static sortString(list, sortProp) {
        list.sort(function(a, b) {
            let nameA = a[sortProp].toUpperCase();
            let nameB = b[sortProp].toUpperCase();

            if (nameA > nameB) {
                return 1;
            }
            if (nameA < nameB) {
                return -1;
            }
            return 0;
        });
    }

    static sortStringSimple(list) {
        list.sort(function(a, b) {
            let nameA = a.toUpperCase();
            let nameB = b.toUpperCase();

            if (nameA > nameB) {
                return 1;
            }
            if (nameA < nameB) {
                return -1;
            }
            return 0;
        });
    }

    static int(value) {
        return parseInt(value);
    }

    static randomiseArray(inArray) {
        let buffer = inArray.concat();
        let element;
        inArray.length = 0;
        while (buffer.length) {
            element = OMath.randomRangeInt(0, buffer.length - 1);
            inArray.push(buffer[element]);
            buffer.splice(element, 1);
        }
    }

    /**
     * @param {String}str
     * @param {String}toReplace
     * @param {String}letters
     * @return  {String}
     */
    static replaceCharInString(str, toReplace, letters) {
        let _pos = [];
        for (let i = 0; i < str.length; i++) {
            i = str.indexOf(toReplace, i);
            if (i != -1) {
                _pos.push(i);
                i += toReplace.length - 1;
            } else {
                break;
            }
        }

        if (_pos.length) {
            for (let i = 0; i < _pos.length; i++) {
                str = str.substring(0, _pos[i]) + letters + str.substring(_pos[i] + letters.length);
            }
        }
        return str;
    }

    /**
     * @param  {string}str
     * @param  {string}replaceInt
     * @param  {string}letters
     * @return {string}
     */
    static StrReplace(str, replaceInt, letters) {
        let rtn = "";
        for (let i = 0; i < str.length; i++) {
            rtn = rtn.concat(i == replaceInt ? letters : str.slice(i, i + 1));
        }
        return rtn;
    }

    /**
     * @param     {Number}value
     * @return         {Number}
     */
    static abs(value) {
        return (value < 0) ? value * -1 : value;
    }

    /**
     * @param     {Number}value
     * @param     {Number}aLower
     * @param     {Number}aUpper
     * @return         {Boolean} true
     */
    static range(value, aLower, aUpper) {
        return ((value > aLower) && (value < aUpper));
    }

    /**
     * @param     {Number}value
     * @param     {Number}out1
     * @param     {Number}out2
     * @return         {Number}
     */
    static closest(value, out1, out2) {
        return (OMath.abs(value - out1) < OMath.abs(value - out1)) ? out1 : out2;
    }

    /**
     * @param     {Number}aLower
     * @param     {Number}aUpper
     * @return         {Number}
     */
    static randomRangeInt(aLower, aUpper) {
        return OMath.int(Math.random() * (aUpper - aLower + 1)) + aLower;
    }

    /**
     * @return         {Boolean}
     */
    static randomBoolean() {
        return OMath.randomRangeInt(0, 1) === 1;
    }

    /**
     * @param     {Number}aLower
     * @param     {Number}aUpper
     * @return    {Number}
     */
    static randomRangeNumber(aLower, aUpper) {
        return Math.random() * (aUpper - aLower) + aLower;
    }

    /**
     * @param     {Array.<Number>}list
     * @return    {Number}
     */
    static randomNumberFromArray(list) {
        if (!list || list.length < 2) {
            OMY.Omy.error("not have random list");
            return 0;
        }
        return OMath.randomRangeNumber(list[0], list[1]);
    }

    static randomList(inArray, outArray, total, copy) {
        copy = copy || false;
        if (!inArray || !outArray) throw new Error("Not Null Array, Pleace");
        if (inArray.length < total) total = inArray.length;
        if (copy) inArray = inArray.concat();
        while (total != outArray.length) {
            outArray.push(inArray.splice(OMath.randomRangeInt(0, inArray.length - 1), 1)[0]);
        }
        outArray = null;
        inArray = null;
    }

    /**
     * Get random item from arguments
     * @returns {*}
     */
    static choicer() {
        return arguments[OMath.randomRangeInt(0, arguments.length - 1)];
    }

    /**
     * Get random item from arguments
     * @param {Array}array
     * @returns {*}
     */
    static getRandomItem(array) {
        return array[OMath.randomRangeInt(0, array.length - 1)];
    }

    /**
     * @param     {Number}aValueA
     * @param     {Number}aValueB
     * @param     {Number}aDiff
     * @return    {Boolean}
     */
    static equal(aValueA, aValueB, aDiff) {
        aDiff = aDiff || 0.00001;
        return (Math.abs(aValueA - aValueB) <= aDiff);
    }

    /**
     * @param     {Number}x1
     * @param     {Number}y1
     * @param     {Number}x2
     * @param     {Number}y2
     * @return    {Number}
     */
    static distance(x1, y1, x2, y2) {
        let dx = x2 - x1;
        let dy = y2 - y1;
        return Math.sqrt(dx * dx + dy * dy);
    }

    /**
     * @param     {Number}x1
     * @param     {Number}y1
     * @param     {Number}x2
     * @param     {Number}y2
     * @param     {Boolean}norm
     * @return    {Number}
     */
    static angle(x1, y1, x2, y2, norm) {
        norm = norm || true;
        let dx = x2 - x1;
        let dy = y2 - y1;
        let angle = Math.atan2(dy, dx);
        return (norm) ? OMath.normAngle(angle) : angle;
    }

    /**
     * @param     {Number}x1
     * @param     {Number}y1
     * @param     {Number}x2
     * @param     {Number}y2
     * @param     {Boolean}norm
     * @return    {Number}
     */
    static angleDeg(x1, y1, x2, y2, norm) {
        norm = norm || true;
        let dx = x2 - x1;
        let dy = y2 - y1;
        let angle = Math.atan2(dy, dx) / Math.PI * 180;
        return (norm) ? OMath.normAngleDeg(angle) : angle;
    }

    /**
     * @param     {Number}aRadians
     * @return    {Number}
     */
    static toDegrees(aRadians) {
        return aRadians * 180 / Math.PI;
    }

    /**
     * @param    {Number} aDegrees
     * @return   {Number}
     */
    static toRadians(aDegrees) {
        return aDegrees * Math.PI / 180;
    }

    /**
     * @param     {Number}aAngle
     * @return    {Number}
     */
    static normAngleDeg(aAngle) {
        return (aAngle < 0) ? 360 + aAngle : (aAngle >= 360) ? aAngle - 360 : aAngle;
    }

    /**
     * @param     {Number}aAngle
     * @return    {Number}
     */
    static normAngle(aAngle) {
        return (aAngle < 0) ? Math.PI * 2 + aAngle : (aAngle >= Math.PI * 2) ? aAngle - Math.PI * 2 : aAngle;
    }

    /**
     * @param     {Number}aCurrent
     * @param     {Number}aTotal
     * @return    {Number}
     */
    static toPercent(aCurrent, aTotal) {
        return (aCurrent / aTotal) * 100;
    }

    /**
     * @param     {Number}aPercent
     * @param     {Number}aTotal
     * @return    {Number}
     */
    static fromPercent(aPercent, aTotal) {
        return (aPercent * aTotal) / 100;
    }

    /**
     * Get value from range by percent [0;100]
     * @param {Number} min
     * @param {Number} max
     * @param {Number} percent
     * @return {Number}
     */
    static valueFromRangeByPercent(min, max, percent) {
        return (percent * (max - min) / 100) + min;
    }

    /**
     * Get percent from range by value
     * @param {Number} min
     * @param {Number} max
     * @param {Number} input
     * @return {Number}
     */
    static percentFromRangeByValue(min, max, input) {
        return ((input - min) * 100) / (max - min);
    }

    /**
     * @param     {Array}aArray
     * @return    {Number}
     */
    static maxFrom(aArray) {
        return Math.max.apply(null, aArray);
    }

    /**
     * @param     {Array}aArray
     * @return    {Number}
     */
    static minFrom(aArray) {
        return Math.min.apply(null, aArray);
    }

    static getMinValueFromVector(vector) {
        let n = vector.length;
        let i;
        let _min = Number.MAX_VALUE;

        for (i = 0; i < n; i++) {
            if (vector[i] < _min)
                _min = vector[i];
        }

        return _min;
    }

    static getMaxValueFromVector(vector) {
        let n = vector.length;
        let i;
        let _max = Number.MIN_VALUE;

        for (i = 0; i < n; i++) {
            if (vector[i] > _max)
                _max = vector[i];
        }

        return _max;
    }

    /**
     * @param     {Number}aVelocity
     * @param     {Number}aAcceleration
     * @param     {Number}aDrag
     * @param     {Number}aMax
     * @return      {Number}
     */
    static calcVelocity(aVelocity, aAcceleration, aDrag, aMax) {
        aAcceleration = aAcceleration || 0;
        aDrag = aDrag || 0;
        aMax = aMax || 10000;

        if (aAcceleration != 0) {
            aVelocity += aAcceleration;
        } else if (aDrag != 0) {
            let dv = aDrag;
            if (aVelocity - dv > 0) {
                aVelocity -= dv;
            } else if (aVelocity + dv < 0) {
                aVelocity += dv;
            } else {
                aVelocity = 0;
            }
        }

        if (aVelocity != 0 && aMax != 10000) {
            if (aVelocity > aMax) {
                aVelocity = aMax;
            } else if (aVelocity < -aMax) {
                aVelocity = -aMax;
            }
        }

        return aVelocity;
    }

    /**
     * @param   {Number}   value
     * @return  {Number}
     */
    static check(value) {
        return value & 1;
    }

    /**
     * @param     {Number}num
     * @param     {Number}round
     * @return  {Number}
     */
    static roundNumber(num, round) {
        return Math.round(num * round) / round;
    }

    /**
     * @param     {Number} num
     * @param     {Number} round
     * @param     {String} split
     * @return  {String}
     */
    static roundNumberString(num, round, split) {
        split = split || ",";
        let valueString = String(OMath.roundNumber(num, round)).split(".");
        valueString[1] = (valueString.length == 1) ? "00" : (valueString[1].length == 1) ? valueString[1] + "0" : valueString[1];
        return valueString[0] + split + valueString[1];
    }

    /**
     * exist value in array or not
     * @param array Array or Vector
     * @param value
     * @return {boolean}
     */
    static inArray(array, value) {
        return (array.indexOf(value) > -1);
    }

    /**
     * Create array with random integer numbers
     * @param {int} lower
     * @param {int} upper
     * @param {int} count
     * @return {Array}
     */
    static createRandomArrayInt(lower, upper, count) {
        let resultArr = [];
        for (let i = 0; i < count; i++) {
            resultArr.push(OMath.randomRangeInt(lower, upper));
        }
        return resultArr;
    }

    static createRandomiseArrayInt(lower, upper, count) {
        if (count > Math.abs(upper - lower)) {
            count = Math.abs(upper - lower);
        }
        let n = count;
        let i;
        let bufferNum;
        let returnArray = [];

        for (i = 0; i < n; i++) {
            bufferNum = OMath.randomRangeInt(lower, upper);
            while (OMath.inArray(returnArray, bufferNum)) {
                bufferNum++;
                if (bufferNum > upper)
                    bufferNum = lower;
            }
            returnArray.push(bufferNum);
        }
        return returnArray;
    }

    static createRandomiseArrayNumber(lower, upper, count) {
        if (count > Math.abs(upper - lower)) {
            count = Math.abs(upper - lower);
        }
        let n = count;
        let i;
        let bufferNum;
        let returnArray = [];

        for (i = 0; i < n; i++) {
            bufferNum = OMath.randomRangeNumber(lower, upper);
            while (OMath.inArray(returnArray, bufferNum)) {
                bufferNum++;
                if (bufferNum > upper)
                    bufferNum = lower;
            }
            returnArray.push(bufferNum);
        }
        return returnArray;
    }

    static getCashString(value, centWith2Zero = true, delaySymbol = ".", numberFormat = false) {
        let valueString = String(OMath.roundNumber(value, 100));
        valueString = valueString.split(".");
        if (centWith2Zero)
            valueString[1] = (valueString.length == 1) ? "00" : (valueString[1].length == 1) ? valueString[1] + "0" : valueString[1];
        else
            valueString[1] = (valueString.length == 1) ? "" : (valueString[1].length == 1) ? valueString[1] + "0" : valueString[1];

        valueString[1] = delaySymbol + valueString[1];

        if (numberFormat) valueString[0] = new Intl.NumberFormat(OMY_SETTING.NUMBER_FORMAT).format(valueString[0]);
        let result = valueString[0] + valueString[1];
        valueString.length = 0;
        valueString = null;
        return result;
    }

    /**
     * Shuffles array in place. ES6 version
     * @param {Array} arr items An array containing the items.
     */
    static shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    /**
     * Generate pseudo unique id with ~13 chars
     * @return {string}
     */
    static uniqueID() {
        return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    }

    /**
     * Make deep copy of json object
     * @param {Object} src
     * @return {Object}
     */
    static jsonCopy(src) {
        return JSON.parse(JSON.stringify(src));
    }

    /**
     * Make deep copy from json copy object to parent json object only exist param
     * @param {Object} parent
     * @param {Object} copy
     * @param {Boolean} force
     * @return
     */
    static objectCopy(parent, copy, force = false) {
        for (let copyKey in copy) {
            if (!force && !parent.hasOwnProperty(copyKey)) continue;
            if (typeof copy[copyKey] === "object" && !Array.isArray(copy[copyKey])) {
                // Omy.warn("object");
                OMath.objectCopy(parent[copyKey], copy[copyKey]);
            } else if (Array.isArray(copy[copyKey])) {
                parent[copyKey] = copy[copyKey].concat();
            } else {
                parent[copyKey] = copy[copyKey];
            }
        }
    }


    /**
     * Convert usual number to number with spaces
     * @param {Number} numb
     * @return {String}
     */
    static convertNumb(numb) {
        return numb.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    }

    /**
     * @param hex
     * @returns {*}
     */
    static hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    /**
     * @param r
     * @param g
     * @param b
     * @returns {string}
     */
    static rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    /**
     * @param i
     * @returns {string}
     * @constructor
     */
    static HexNumberToString(rgb) {
        rgb = rgb.toString(16);
        return "#" + rgb.substr(0, 2) + rgb.substr(2, 2) + rgb.substr(4, 2);
    }

    /**
     * @param rgb
     * @returns {number}
     * @constructor
     */
    static HexStringToNumber(rgb) {
        rgb = rgb.replace("#", "");
        return parseInt((rgb.substr(0, 2) + rgb.substr(2, 2) + rgb.substr(4, 2)), 16);
    }
}
